module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ded"
  }, [_c('a', {
    attrs: {
      "id": "dedication"
    }
  }), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("For America’s diplomats and development experts, who represent our country and our values so well in places large and small, peaceful and perilous all over the world.")])])]), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_c('p', {
    staticClass: "ded1"
  }, [_vm._v("and")]), _vm._v(" "), _c('p', {
    staticClass: "deda"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("In memory of my parents:")])]), _vm._v(" "), _c('p', {
    staticClass: "deda"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Hugh Ellsworth Rodham (1911–1993)")])])]), _c('p', {
    staticClass: "deda"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Dorothy Emma Howell Rodham (1919–2011)")])]), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d6dd37b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/dedication.vue
// module id = 75
// module chunks = 0